import { render, staticRenderFns } from "./account-unpaid.vue?vue&type=template&id=fa88f8d2&"
import script from "./account-unpaid.vue?vue&type=script&lang=js&"
export * from "./account-unpaid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports